import { createSelector } from '@ngrx/store';
import { SelectSupplierModuleState } from '../suppliermodule.selector';

export const SelectEventData = createSelector(SelectSupplierModuleState, state => state.EventState.Event);
export const SelectSecurityEventData = createSelector(SelectSupplierModuleState, state => state.EventState.SecurityEvent);
